namespace TabAurous.Inventory {
    export interface CertificationIssueRow {
        TransId?: number;
        TransDate?: string;
        RefTransId?: number;
        RefVoucherId?: number;
        VoucherNo?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        PartyId?: number;
        LedgerName?: string;
        PartyCode?: string;
        GstVat?: string;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        BaseItemTypeId?: number;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        RoundOff?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        PostingDate?: string;
        IsPosted?: boolean;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        BillAddId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: CertificationIssueItemsRow[];
        DepartmentId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        Username?: string;
    }

    export namespace CertificationIssueRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.CertificationIssue';
        export const deletePermission = 'Inventory:CertificationIssue:Delete';
        export const insertPermission = 'Inventory:CertificationIssue:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:CertificationIssue:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            RefTransId = "RefTransId",
            RefVoucherId = "RefVoucherId",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            GstVat = "GstVat",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            BaseItemTypeId = "BaseItemTypeId",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            RoundOff = "RoundOff",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            BillAddId = "BillAddId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            DepartmentId = "DepartmentId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            Username = "Username"
        }
    }
}
